import { useContext, useEffect, useState, useRef } from "react";
import { DataContext } from "../../../context/DataContext";
import { petitions } from "../../../api/calls";
import { toast } from "sonner";
import {useForm} from 'react-hook-form'
import Swal from 'sweetalert2';

function AreaLocal() {
  const {session, idEmpresa } = useContext(DataContext);
  const [area, setArea] = useState([]);
  const [local, setLocal] = useState([]);
  const [estadoArea, setEstadoArea] = useState(false)
  const [estadoLocal, setEstadoLocal] = useState(false)

  const [searchArea, setSearchArea] = useState("");
  const [searchLocal, setSearchLocal] = useState("");

  const form1 = useForm();
  const form2 = useForm();

  //FILTROS
  const filteredArea = area.filter((obj) =>
    obj.nomArea.toLowerCase().includes(searchArea.toLowerCase())
  );

  const filteredLocal = local.filter((obj) =>
    obj.nomLocal.toLowerCase().includes(searchLocal.toLowerCase())
  );

  //MODALS
  const modalRef1 = useRef(null);
  const modalRef2 = useRef(null);

  const closeModal1 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef1.current);
    modalInstance.hide();
  };

  const closeModal2 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
    modalInstance.hide();
  };

  useEffect(() => {
    const fetchAreas = async () => {
      const obj = session();
      const response = await petitions.getAreas(idEmpresa(), obj.token);
      if (response.status === "success") {
        setArea(response.data);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchAreas();
  }, [estadoArea, session, idEmpresa]);

  useEffect(() => {
    const fetchLocal = async () => {
      const obj = session();
      const response = await petitions.getLocal(idEmpresa(), obj.token);
      if (response.status === "success") {
        setLocal(response.data);
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchLocal();
  }, [estadoLocal, session, idEmpresa]);


  //AREA
  const sendArea = form1.handleSubmit(async (data) => {
    var obj = session();
    const response = await petitions.insertArea(idEmpresa(), obj.token,data)    
    if (response.status === "success") {
      if (response.data) {
        closeModal1();
        response.data ? toast.success("Área registrada correctamente") : toast.error("No se pudo registrar la área");
        setEstadoArea(!estadoArea)
        form1.reset(); 
      }
      else{
        closeModal1();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      closeModal1();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const deleteArea = (idArea) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
    });
    
    swalWithBootstrapButtons.fire({
      title: "Estas seguro/a?",
      text: "No podrás cancelar el proceso",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "No, cancelar",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
          var obj = session();
          const response = await petitions.deleteArea(idEmpresa(), obj.token, {idArea});
          if (response.status === "success") {
            if (response.data) {
              setEstadoArea(!estadoArea)
              toast.success("Area eliminada correctamente")
            }
            else{
              toast.warning("Ocurrió un problema, inténtelo mas tarde");  
            }
          } else {
            var msg = typeof response.code === "string" ? response.message : response.data;
            toast.error(msg);
          }
      }
    });
  }

  //LOCAL
  const sendLocal = form2.handleSubmit(async (data) => {
    var obj = session();
    const response = await petitions.insertLocal(idEmpresa(), obj.token,data)
    if (response.status === "success") {
      if (response.data) {
        closeModal2();
        setEstadoLocal(!estadoLocal)
        toast.success("Local registrado correctamente")
        form2.reset();
      }
      else{
        closeModal2("Ocurrió un problema, inténtelo mas tarde");
        toast.warning(msg);
      }
    } else {
      closeModal2();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const deleteLocal = (idLocal) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
    });
    
    swalWithBootstrapButtons.fire({
      title: "Estas seguro/a?",
      text: "No podrás cancelar el proceso",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "No, cancelar",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
          var obj = session();
          const response = await petitions.deleteLocal(idEmpresa(), obj.token, {idLocal});
          if (response.status === "success") {
            if (response.data) {
              setEstadoLocal(!estadoLocal)
              toast.success("Local eliminado correctamente") 
            }
            else{
              toast.warning("Ocurrió un problema, inténtelo mas tarde");  
            }
          } else {
            var msg = typeof response.code === "string" ? response.message : response.data;
            toast.error(msg);
          }
      }
    });
  }

  return (
    <>
      <div className="row gy-3 mb-4 justify-content-between">
        <div className="col-md-9 col-auto">
          <h2 className="mb-2 text-body-emphasis">Área y local</h2>
          <h5 className="text-body-tertiary fw-semibold">
            Gestiona áreas y locales de tu empresa.
          </h5>
        </div>
      </div>
      <div className="mx-lg-n4 mt-3">
        <div className="row g-3">
          <div className="col-12 col-xl-6 col-xxl-7">
            <div className="card todo-list h-100 rounded-4">
              <div className="card-header border-bottom-0 pb-0">
                <div className="row justify-content-between align-items-center mb-4">
                  <div className="col-auto">
                    <h3 className="text-body-emphasis">Área</h3>
                    <p className="mb-0 text-body-tertiary">
                      Áreas disponibles de la empresa
                    </p>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div className="col-auto w-100 w-md-auto">
                    <div className="row align-items-center g-0 justify-content-between">
                      <div className="col-12 col-sm-auto">
                        <div
                          className="search-box w-100 mb-2 mb-sm-0"
                          style={{ maxWidth: "30rem" }}
                        >
                            <input
                              className="form-control search-input search rounded-4"
                              type="search"
                              placeholder="Buscar áreas"
                              aria-label="Search"
                              onChange={(event) => {setSearchArea(event.target.value)}}
                            />
                            <span className="fas fa-search search-box-icon"></span>
                        </div>
                      </div>
                      <div className="col-auto d-flex">
                        <p className="mb-0 ms-sm-3 fs-9 text-body-tertiary fw-bold">
                          <span className="fas fa-filter me-1 fw-extra-bold fs-10"></span>
                          {area.length} áreas
                        </p>
                        <div
                          className={
                            "btn btn-link p-0 ms-3 fs-9 text-" +
                            (area.length > 0 ? "primary" : "danger") +
                            " fw-bold"
                          }
                        >
                          <span className="fas fa-sort me-1 fw-extra-bold fs-10"></span>
                          Estado
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body py-0 scrollbar to-do-list-body">
                {filteredArea &&
                  filteredArea.map((a) => (
                    <div
                      className="d-flex hover-actions-trigger py-3 border-top"
                      key={a.idArea}
                    >
                      <div className="row justify-content-between align-items-md-center btn-reveal-trigger border-translucent gx-0 flex-1">
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="mb-1 mb-md-0 d-flex align-items-center lh-1">
                            <label className="form-check-label mb-1 mb-md-0 mb-xl-1 mb-xxl-0 fs-8 me-2 line-clamp-1 text-body">
                              {a.nomArea}
                            </label>
                            <button className="badge badge-phoenix ms-auto fs-10 badge-phoenix-info" disabled={true} style={{display:"none"}}>
                              editar
                            </button>
                            <button className="badge badge-phoenix  ms-auto ms-2 fs-10 badge-phoenix-danger rounded-4" onClick={() =>{deleteArea(a.idArea)}}>
                              eliminar
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="d-flex lh-1 align-items-center">
                            <div className="hover-md-hide hover-xl-show hover-xxl-hide">
                              <p className="text-body-tertiary fs-10 fw-bold mb-md-0 mb-0 ps-md-3 ps-xl-0 ps-xxl-3 border-start-md border-xl-0 border-start-xxl">
                                {}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="card-footer border-0">
                <a
                  className="fw-bold fs-9 mt-4"
                  data-bs-toggle="modal"
                  data-bs-target="#modalAgregarArea"
                >
                  <span className="fas fa-plus me-1"></span>Agregar nueva área
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6 col-xxl-7">
            <div className="card todo-list h-100 rounded-4">
              <div className="card-header border-bottom-0 pb-0">
                <div className="row justify-content-between align-items-center mb-4">
                  <div className="col-auto">
                    <h3 className="text-body-emphasis">Local</h3>
                    <p className="mb-0 text-body-tertiary">
                      Locales disponibles de la empresa
                    </p>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div className="col-auto w-100 w-md-auto">
                    <div className="row align-items-center g-0 justify-content-between">
                      <div className="col-12 col-sm-auto">
                        <div
                          className="search-box w-100 mb-2 mb-sm-0"
                          style={{ maxWidth: "30rem" }}
                        >
                            <input
                              className="form-control search-input search rounded-4"
                              type="search"
                              placeholder="Buscar locales"
                              aria-label="Search"
                              onChange={(event) => {setSearchLocal(event.target.value)}}
                            />
                            <span className="fas fa-search search-box-icon"></span>
                        </div>
                      </div>
                      <div className="col-auto d-flex">
                        <p className="mb-0 ms-sm-3 fs-9 text-body-tertiary fw-bold">
                          <span className="fas fa-filter me-1 fw-extra-bold fs-10"></span>
                          {local.length} locales
                        </p>
                        <div
                          className={
                            "btn btn-link p-0 ms-3 fs-9 text-" +
                            (local.length > 0 ? "primary" : "danger") +
                            " fw-bold"
                          }
                        >
                          <span className="fas fa-sort me-1 fw-extra-bold fs-10"></span>
                          Estado
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body py-0 scrollbar to-do-list-body">
              {filteredLocal &&
                  filteredLocal.map((l) => (
                    <div
                      className="d-flex hover-actions-trigger py-3 border-top"
                      key={l.idLocal}
                    >
                      <div className="row justify-content-between align-items-md-center btn-reveal-trigger border-translucent gx-0 flex-1">
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="mb-1 mb-md-0 d-flex align-items-center lh-1">
                            <label className="form-check-label mb-1 mb-md-0 mb-xl-1 mb-xxl-0 fs-8 me-2 line-clamp-1 text-body">
                              {l.nomLocal}
                            </label>
                            <button className="badge badge-phoenix ms-auto fs-10 badge-phoenix-info" disabled={true} style={{display:"none"}}>
                              editar
                            </button>
                            <button className="badge badge-phoenix ms-auto ms-2 fs-10 badge-phoenix-danger rounded-4" onClick={() => {deleteLocal(l.idLocal)}}>
                              eliminar
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="d-flex lh-1 align-items-center">
                            <div className="hover-md-hide hover-xl-show hover-xxl-hide">
                              <p className="text-body-tertiary fs-10 fw-bold mb-md-0 mb-0 ps-md-3 ps-xl-0 ps-xxl-3 border-start-md border-xl-0 border-start-xxl">
                                {l.dirLocal}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="card-footer border-0">
                <a className="fw-bold fs-9 mt-4" data-bs-toggle="modal" data-bs-target="#modalAgregarLocal">
                  <span className="fas fa-plus me-1"></span>Agregar nuevo local
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MODALS */}
      <div
        className="modal fade"
        id="modalAgregarArea"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Área
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendArea}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Nombre de área</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form1.register("nomArea",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    }
                  })}/>
                  { form1.formState.errors?.nomArea && <code>{form1.formState.errors.nomArea.message}</code> } 
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Local</label>
                  <select className="form-select rounded-4" {...form1.register("idLocal",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    }
                  })}>
                    {local.map(option => (
                      <option key={option.idLocal} value={option.idLocal}>
                        {option.nomLocal}
                      </option>
                    ))}
                  </select>
                  { form1.formState.errors?.idLocal && <code>{form1.formState.errors.idLocal.message}</code> } 
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4"type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>


      <div
        className="modal fade"
        id="modalAgregarLocal"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de Local
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendLocal}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Nombre del local</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form2.register("nomLocal",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    }
                  })}/>
                  { form2.formState.errors?.nomLocal && <code>{form2.formState.errors.nomLocal.message}</code> } 
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Dirección</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form2.register("dirLocal",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    }
                  })}/>
                  { form2.formState.errors?.dirLocal && <code>{form2.formState.errors.dirLocal.message}</code> }
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AreaLocal;
